import type * as React from 'react';

export enum ToastType {
  ERROR = `error`,
  INFO = `info`,
  SUCCESS = `success`,
  DESTRUCTIVE = `destructive`,
  WARNING = `warning`,
}

export interface ToastActionEvent {
  preventDefault: () => void;
}

export interface ToastProps {
  cta?: string;
  ctaHref?: string;
  ctaTarget?: string;
  elref?: string;
  hide?: boolean;
  hideCancelButton?: boolean;
  message?: React.ReactNode;
  timeout?: number | null;
  type?: ToastType;
  undoable?: boolean;
  undoLabel?: string;
  onAction?: (ev: ToastActionEvent) => void;
  onClose?: () => void;
  onUndo?: (ev: ToastActionEvent) => void;
}
